// plugins/socket.client.ts
import { io } from "socket.io-client";

let socket;
let connectedWithToken = null;

/**
 * The session token of the `token` cookie. Sent on each (re)connection: the API puts the socket in the rooms of its
 * user's printer and of the administrators, where production generation events go once they are no longer broadcast
 * to every client.
 */
const sessionToken = () => {
  const entry = document.cookie.split("; ").find((cookie) => cookie.startsWith("token="));
  return entry ? decodeURIComponent(entry.slice("token=".length)) || null : null;
};

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  if (!socket) socket = io(config.public.apiBase, {
    reconnection: true,
    reconnectionDelay: 3000,
    auth: (send) => {
      connectedWithToken = sessionToken();
      send({ token: connectedWithToken });
    }
  });

  /** Reconnects when the session changed since the connection (a login after the app loaded), to join its rooms. */
  const ensureSocketSession = () => {
    if (socket && sessionToken() !== connectedWithToken) {
      socket.disconnect();
      socket.connect();
    }
  };

  return {
    provide: {
      socket,
      ensureSocketSession
    }
  };
});
